<template>
    <component
        :is="is || 'div'"
        :class="$style.section"
    >
        <slot />
    </component>
</template>
<script lang="ts" setup>
defineProps<{
    is?: 'section' | 'div'
}>()
</script>
<style module>
.section {
    border-top: 1px solid var(--white-16);
    padding-top: var(--gap-32);
    margin: var(--gap-32) 0 var(--gap-24);
}

@media (--desktop-small-plus) {
    .section {
        padding-top: 24px;
        margin: 24px 0 var(--gap-24);
    }
}
</style>
